interface IconProps {
  size?: number;
  color?: string;
}

function mk(paths: React.ReactNode) {
  return function Icon({ size = 22, color = "currentColor" }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {paths}
      </svg>
    );
  };
}

function mkFill(paths: React.ReactNode) {
  return function Icon({ size = 22, color = "currentColor" }: IconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {paths}
      </svg>
    );
  };
}

export const Icons = {
  Home: mk(
    <path d="M3 11l9-8 9 8v10a1 1 0 0 1-1 1h-5v-7h-6v7H4a1 1 0 0 1-1-1z" />,
  ),
  Feed: mk(
    <>
      <path d="M3 6h18" />
      <path d="M3 12h18" />
      <path d="M3 18h12" />
    </>,
  ),
  Map: mk(
    <>
      <path d="M9 4l-6 2v14l6-2 6 2 6-2V4l-6 2z" />
      <path d="M9 4v14" />
      <path d="M15 6v14" />
    </>,
  ),
  Entities: mk(
    <>
      <circle cx="6" cy="6" r="2.5" />
      <circle cx="18" cy="6" r="2.5" />
      <circle cx="6" cy="18" r="2.5" />
      <circle cx="18" cy="18" r="2.5" />
      <path d="M8.5 6H15.5M6 8.5V15.5M18 8.5V15.5M8.5 18H15.5" />
    </>,
  ),
  Dispatch: mk(
    <>
      <path d="M4 12h16" />
      <path d="M12 4v16" />
      <path d="M6 8l-2 4 2 4" />
      <path d="M18 8l2 4-2 4" />
    </>,
  ),
  Search: mk(
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-3.5-3.5" />
    </>,
  ),
  Bell: mk(
    <>
      <path d="M6 8a6 6 0 1 1 12 0c0 7 3 8 3 8H3s3-1 3-8" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </>,
  ),
  ChevRight: mk(<path d="M9 6l6 6-6 6" />),
  ChevDown: mk(<path d="M6 9l6 6 6-6" />),
  Close: mk(
    <>
      <path d="M6 6l12 12" />
      <path d="M18 6L6 18" />
    </>,
  ),
  Check: mk(<path d="M5 12l5 5 9-11" />),
  Zap: mk(<path d="M13 3L4 14h7l-1 7 9-11h-7l1-7z" />),
  Alert: mk(
    <>
      <path d="M12 2l10 18H2z" />
      <path d="M12 9v5" />
      <path d="M12 17v.5" />
    </>,
  ),
  Clock: mk(
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>,
  ),
  Branch: mk(
    <>
      <circle cx="6" cy="4" r="2" />
      <circle cx="6" cy="20" r="2" />
      <circle cx="18" cy="12" r="2" />
      <path d="M6 6v12M8 12h8M6 6c0 4 6 4 6 6" />
    </>,
  ),
  Play: mk(<path d="M6 4l14 8-14 8z" />),
  Filter: mk(
    <>
      <path d="M3 5h18" />
      <path d="M6 12h12" />
      <path d="M10 19h4" />
    </>,
  ),
  Dot: mkFill(<circle cx="12" cy="12" r="4" />),
  Link: mk(
    <>
      <path d="M10 13a4 4 0 0 0 5.66 0l3-3a4 4 0 1 0-5.66-5.66l-1 1" />
      <path d="M14 11a4 4 0 0 0-5.66 0l-3 3a4 4 0 1 0 5.66 5.66l1-1" />
    </>,
  ),
  AtSign: mk(
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
    </>,
  ),
  Bookmark: mk(<path d="M6 3h12v18l-6-4-6 4z" />),
  Reply: mk(
    <>
      <path d="M9 17l-5-5 5-5" />
      <path d="M4 12h11a5 5 0 0 1 5 5v3" />
    </>,
  ),
  Pause: mkFill(
    <path d="M7 4h4v16H7zM13 4h4v16h-4z" fill="currentColor" />,
  ),
  RewindArrow: mk(
    <>
      <path d="M3 12a9 9 0 1 0 3-6.7" />
      <path d="M3 4v5h5" />
    </>,
  ),
  Hand: mk(
    <>
      <path d="M9 11V5a1.5 1.5 0 1 1 3 0v5" />
      <path d="M12 10V4a1.5 1.5 0 1 1 3 0v6" />
      <path d="M15 10V6a1.5 1.5 0 1 1 3 0v8" />
      <path d="M9 11V8a1.5 1.5 0 1 0-3 0v8a6 6 0 0 0 6 6h2a6 6 0 0 0 6-6v-2" />
    </>,
  ),
  Diagnostics: mk(
    <>
      <path d="M3 12h4l2 5 4-14 2 9h6" />
    </>,
  ),
  Docs: mk(
    <>
      <path d="M6 3h9l4 4v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h6M9 17h6" />
    </>,
  ),
  Ops: mk(
    <>
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </>,
  ),
  Settings: mk(
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </>,
  ),
};

export type { IconProps };
